import React from 'react';
import { useStyles } from './Footer.styles';

export const Footer: React.FC = ({ children }) => {
  const classes = useStyles();

  return <div className={classes.container}>{children}</div>;
};
